import AddIcon from "@mui/icons-material/Add";
import React, { useState, useContext } from "react";
import deleteIcon from "../../../assets/images/delete_icon.svg";
import editIcon from "../../../assets/images/edit_icon.svg";
import AddOfficerModal from "../../../components/elements/AddOfficerModal";
import DeleteModal from "../../../components/elements/DeleteModal";
import Modal from "../../../components/elements/Modal";
import { StorageContext } from "../../../services/StorageProvider";
import { useFormData } from "../../../helper/FormDataProvider";
import { ClearanceStatus as Status } from "../../../utils/constants";
import { hasAirportAccess } from "../../../utils/Utils";
import "../css/AfterHoursOfficersList.css";

const AfterHoursOfficersList = ({
  officers,
  onAddOfficer,
  onEditOfficer,
  onDeleteOfficer,
  clearanceStatus,
  tripPhase,
  airportId,
  isAutoApprove,
}) => {
  const { userData } = useFormData();
  const { airportData } = useContext(StorageContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [officerToDelete, setOfficerToDelete] = useState(null);
  const [editingOfficer, setEditingOfficer] = useState(null);

  // Check if user has access to the airport
  const hasAirportAccessForOfficers = hasAirportAccess(
    userData,
    airportData,
    airportId
  );

  const handleAddOfficerClick = () => {
    setIsModalOpen(true);
  };

  const handleEditClick = (officer, index) => {
    setEditingOfficer({ ...officer, index });
    setIsModalOpen(true);
  };

  const handleDeleteClick = (index) => {
    if (officers.length <= 2) {
      // Don't allow deletion if only 2 officers remain
      return;
    }
    setOfficerToDelete(index);
    setIsDeleteModalOpen(true);
  };
  const confirmDeleteOfficer = () => {
    if (officerToDelete !== null) {
      onDeleteOfficer(officerToDelete);
    }
    setIsDeleteModalOpen(false);
    setOfficerToDelete(null);
  };

  const cancelDelete = () => {
    setIsDeleteModalOpen(false);
    setOfficerToDelete(null);
  };
  const isApproved =
    clearanceStatus === Status.PAID ||
    clearanceStatus === Status.CLEARANCE_REJECTED ||
    clearanceStatus === Status.CANCELLED ||
    clearanceStatus === Status.CORRECTION_REQUESTED ||
    isAutoApprove;

  const handleAddOfficer = (selectedOfficers) => {
    if (editingOfficer) {
      onEditOfficer(editingOfficer.index, selectedOfficers[0]);
    } else {
      const displayOfficers = selectedOfficers;
      const officersWithPhase = selectedOfficers.map((officer) => ({
        officerId: officer.officerId,
        tripPhase: tripPhase,
        hoursWorked: officer.hoursWorked,
      }));

      onAddOfficer({
        apiData: officersWithPhase,
        displayData: displayOfficers,
      });
    }
  };

  return (
    <div>
      <div className="after-hours-officers-list">
        <div className="after-hours-officers-header">
          <p>Added Officers</p>
          {!isApproved && (
            <button
              className={`after-hours-add-officer-btn ${!hasAirportAccessForOfficers ? 'disabled' : ''}`}
              onClick={hasAirportAccessForOfficers ? handleAddOfficerClick : undefined}
              disabled={!hasAirportAccessForOfficers}
              data-testid={`add-officer-button-${tripPhase.toLowerCase()}`}
            >
              <AddIcon />
              Add Officer
            </button>
          )}
        </div>
        <div
          className="after-hours-officers-box"
          data-testid={`officers-list-${tripPhase.toLowerCase()}`}
        >
          {officers.length > 0 ? (
            officers.map((officer, index) => (
              <div key={index} className="after-hours-officer" data-testid={`officer-${index}`}>
                <p>
                  {officer.name} - {officer.hoursWorked} hrs
                </p>
                {!isApproved && hasAirportAccessForOfficers && (
                  <div className="after-hours-officer-actions">
                    <img
                      src={editIcon}
                      alt="edit icon"
                      className="after-hours-edit-icon"
                      onClick={() => handleEditClick(officer, index)}
                    />
                    {officers.length > 2 && (
                      <img
                        src={deleteIcon}
                        alt="delete icon"
                        className="after-hours-delete-icon"
                        onClick={() => handleDeleteClick(index)}
                      />
                    )}
                  </div>
                )}
              </div>
            ))
          ) : (
            <p>No officers added</p>
          )}
        </div>
      </div>
      <Modal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setEditingOfficer(null);
        }}
      >
        <AddOfficerModal
          tripPhase={tripPhase}
          isAfterHourPopUp={true}
          onAddOfficer={handleAddOfficer}
          onClose={() => {
            setIsModalOpen(false);
            setEditingOfficer(null);
          }}
          airportId={airportId}
          existingOfficers={officers.filter((_, i) =>
            editingOfficer ? i !== editingOfficer.index : true
          )}
          editingOfficer={editingOfficer}
        />
      </Modal>
      <DeleteModal
        isOpen={isDeleteModalOpen}
        onClose={cancelDelete}
        onDelete={confirmDeleteOfficer}
      />
    </div>
  );
};

export default AfterHoursOfficersList;
